import { render, staticRenderFns } from "./PlatformCoverBlock.vue?vue&type=template&id=38fad644&scoped=true&"
import script from "./PlatformCoverBlock.vue?vue&type=script&lang=js&"
export * from "./PlatformCoverBlock.vue?vue&type=script&lang=js&"
import style0 from "./PlatformCoverBlock.vue?vue&type=style&index=0&id=38fad644&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fad644",
  null
  
)

export default component.exports